import {
  USE_MOCK_DATA,
  FETCHING_SEARCH_CONFIRM_LOCATIONS,
  FETCHING_SEARCH_CONFIRM_LOCATIONS_SUCCESSFUL,
  FETCHING_SEARCH_CONFIRM_LOCATIONS_FAILED
} from "../../constants";

var initialState = {
  locationSuggestions: { originSuggestions: [], destinationSuggestions: [] } // added defaults to prevent location suggestions page from crashing when accessing during data fetch
};

if (USE_MOCK_DATA) {
  // const rawTripsDeparting = require("../../../../server/test/mocks/RoundTrip_Departing.json"); // Departing + RounTrip
  const rawTripsDeparting = require("../../../../server/test/mocks/FlightDepartures_OneWay_Overnight_2.json"); // Departing + RounTrip
  const rawTripsReturning = require("../../../../server/test/mocks/FlightReturns_RoundTrip.json"); // Returning + RounTrip
  // const installmentInfo = require("../../../../server/test/mocks/InstallmentInfo.json");
  const installmentInfo = require("../../../../server/test/mocks/FlightContract_2_Passengers.json");
  const reservedTrip = require("../../../../server/test/mocks/Confirmed_Trip.json");
  const locationSuggestions = require("../../../../server/test/mocks/Location_Suggestions.json");

  const departingTrips = rawTripsDeparting.trips; // Test Departing trip data
  const returningTrips = rawTripsReturning.trips; // Test Returning trip data
  const selectedDepartingTripId = departingTrips[1].id; // Test Id, random trip
  // const selectedReturningTripId = returningTrips[0].id; // Test Id, random trip

  // Initial state would be test data in development mode
  initialState = {
    locationSuggestions,
    installmentInfo,
    selectedDepartingTripId,
    // selectedReturningTripId,
    departingTrips,
    returningTrips,
    reservedTrip
  };
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_RESERVED_TRIP": {
      return { ...state, reservedTrip: action.payload };
    }
    case FETCHING_SEARCH_CONFIRM_LOCATIONS: {
      return {
        ...state,
        fetchingLocationSuggestions: true
      };
    }
    case FETCHING_SEARCH_CONFIRM_LOCATIONS_SUCCESSFUL: {
      return {
        ...state,
        fetchingLocationSuggestions: false,
        locationSuggestions: action.payload
      };
    }
    case FETCHING_SEARCH_CONFIRM_LOCATIONS_FAILED: {
      return {
        ...state,
        fetchingLocationSuggestions: false
      };
    }
    case "FETCHING_TRIP_BY_ID": {
      return { ...state, fetchingTrips: true };
    }
    case "FETCHING_TRIP_BY_ID_FAILURE": {
      return {
        ...state,
        fetchingTrips: false,
        errorFetchTripById: action.payload
      };
    }
    case "FETCHING_TRIP_BY_ID_SUCCESSFUL": {
      return { ...state, fetchingTrips: false, reservedTrip: action.payload };
    }
    case "FETCHING_DEPARTING_TRIPS": {
      return { ...state, fetchingTrips: true };
    }
    case "FETCHING_RETURNING_TRIPS": {
      return { ...state, fetchingTrips: true };
    }
    case "FETCHING_INSTALLMENT_INFO": {
      return { ...state, fetchingTrips: true };
    }
    case "FETCHING_DEPARTING_TRIPS_SUCCESSFUL": {
      return {
        ...state,
        fetchingTrips: false,
        // departingTrips: TripParserClient(action.payload)
        departingTrips: action.payload
      };
    }
    case "FETCHING_RETURNING_TRIPS_SUCCESSFUL": {
      return {
        ...state,
        fetchingTrips: false,
        // returningTrips: TripParserClient(action.payload)
        returningTrips: action.payload
      };
    }
    case "FETCHING_INSTALLMENT_INFO_SUCCESSFUL": {
      return {
        ...state,
        fetchingTrips: false,
        installmentInfo: action.payload
      };
    }
    case "FETCHING_DEPARTING_TRIPS_REJECTED": {
      return { ...state, fetchingTrips: false, error: action.payload };
    }
    case "FETCHING_RETURNING_TRIPS_REJECTED": {
      return { ...state, fetchingTrips: false, error: action.payload };
    }
    case "FETCHING_INSTALLMENT_INFO_REJECTED": {
      return { ...state, fetchingTrips: false, error: action.payload };
    }
    case "SELECT_TRIP": {
      const { tripId, tripType } = action.payload;
      if (tripType === "DEPARTING")
        return { ...state, selectedDepartingTripId: tripId };
      return { ...state, selectedReturningTripId: tripId }; // else, this is 'RETURNING'
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/data/trips/reducer.js